import { render, staticRenderFns } from "./blogsCom.vue?vue&type=template&id=5fce4fb3&scoped=true"
import script from "./blogsCom.vue?vue&type=script&lang=js"
export * from "./blogsCom.vue?vue&type=script&lang=js"
import style0 from "./blogsCom.vue?vue&type=style&index=0&id=5fce4fb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fce4fb3",
  null
  
)

export default component.exports